import React from 'react';
import { Link } from 'react-router-dom';
import ReactJson from 'react-json-view'
import { inject, observer } from "mobx-react";
import BN from 'bignumber.js'
import swal from 'sweetalert';
import Select from 'react-select';

@inject("UiStore")
@observer
export class ThirdStep extends React.Component {
  constructor(props){
    super(props);
    this.tokenStore = props.UiStore.tokenStore;
    this.gasPriceStore = props.UiStore.gasPriceStore;
    console.log(this.gasPriceStore.gasPricesArray)
    this.onNext = this.onNext.bind(this)
    this.state = {
      gasPrice: ''
    }
  }
  componentDidMount() {
    if(this.tokenStore.dublicates.length > 0){

      swal({
        title: `你的列表上有重复的地址。`,
        text: `${JSON.stringify(this.tokenStore.dublicates.slice(), null, '\n')}.\n 我们已经合并了这些地址的余额。请确保计算正确。`,
        icon: "warning",
      })
    }
  }
  onNext(e) {
    e.preventDefault();
    if (new BN(this.tokenStore.totalBalance).gt(new BN(this.tokenStore.defAccTokenBalance))){
      console.error('你的Token余额不足')
      swal({
        title: "token 数量不足",
        text: `您没有足够的Token发送到所有的地址。\n需要的数量: ${this.tokenStore.totalBalance} ${this.tokenStore.tokenSymbol}`,
        icon: "error",
      })
      return
    }
    if( new BN(this.tokenStore.totalCostInEth).gt(new BN(this.tokenStore.ethBalance))){
      console.error('please fund you account in ')
      swal({
        title: "请为你提供资金 ",
        text: `你没有足够的ETH发送到所有地址。需要的数量: ${this.tokenStore.totalCostInEth} ETH`,
        icon: "error",
      })
      return
    }
    this.props.history.push('/4')
  }

  onGasPriceChange = (selected) => {
    if(selected){
      this.gasPriceStore.setSelectedGasPrice(selected.value)
    }
  }
  render() {
    return (
      <div className="container container_bg">
        <div className="content">
          <h1 className="title"><strong>欢迎使用</strong> 批量ETH or TOKEN 转账</h1>
          <p className="description">
          请提供token地址，JSON文件地址 <br />
          这个应用程序支持主网, 测试网等多种网络
          </p>
          <form className="form">
            <ReactJson displayDataTypes={false}
              style={{backgroundColor: 'none'}}
              indentWidth="2"
              iconStyle="square"
              name={false}
              theme="solarized"
              src={this.tokenStore.jsonAddresses.slice()} />
              <div style={{padding: "25px 0px"}}>
                <p>网络速度 (Gas Price)</p>
                <Select.Creatable
                  isLoading={this.gasPriceStore.loading}
                  value={this.gasPriceStore.selectedGasPrice}
                  onChange={this.onGasPriceChange}
                  loadingPlaceholder="获取gas Price数据……"
                  placeholder="请选择所需的网络速度"
                  options={this.gasPriceStore.gasPricesArray.slice()}
                />
              </div>
            <div className="send-info">
              <div className="send-info-side">
                <div className="send-info-i">
                  <p>要发送的总代币</p>
                  <p className="send-info-amount">{this.tokenStore.totalBalance} {this.tokenStore.tokenSymbol}</p>
                </div>
                <div className="send-info-i">
                  <p>你的余额</p>
                  <p className="send-info-amount">{this.tokenStore.defAccTokenBalance} {this.tokenStore.tokenSymbol}</p>
                </div>
                <div className="send-info-i">
                  <p>你的ETH余额</p>
                  <p className="send-info-amount">{this.tokenStore.ethBalance}</p>
                </div>
                <div className="send-info-i">
                  <p>估计手续费</p>
                  <p className="send-info-amount">
                  {this.tokenStore.totalCostInEth} ETH        
                  </p>
                </div>
              </div>
              <div className="send-info-side">
                <div className="send-info-i">
                  <p>要发送的总地址</p>
                  <p className="send-info-amount">{this.tokenStore.jsonAddresses.length}</p>
                </div>
                <div className="send-info-i">
                  <p>已获取授权数量</p>
                  <p className="send-info-amount">{this.tokenStore.allowance} {this.tokenStore.tokenSymbol}</p>
                </div>
                <div className="send-info-i">
                  <p>需要发送次数</p>
                  <p className="send-info-amount">{this.tokenStore.totalNumberTx}</p>
                </div>
                <div className="send-info-i">
                  <p>选择网络速度 (Gas Price)</p>
                  <p className="send-info-amount">
                  {this.gasPriceStore.selectedGasPrice} gwei
                  </p>
                </div>
              </div>
            </div>
            
            <Link onClick={this.onNext} className="button button_next" to='/4'>下一步</Link>
          </form>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/3.js